<template>
  <div class="container">
    <el-result
      icon="success"
      title="恭喜你，注册成功!"
      subTitle=""
    >
      <template slot="extra">
        <el-button type="primary" size="medium" @click="goToLogin">返回登录页 ></el-button>
      </template>
    </el-result>
  </div>
</template>
<style scoped>
.container{width: 980px;margin:0 auto;}
</style>
<script>

export default {
   name: "RegSucc",
   methods:{
    goToLogin(){
      this.$router.push({ name: "login" }); 
    }
   }
}
</script>
